import { render, staticRenderFns } from "./HistoryBidComponent.vue?vue&type=template&id=480b2a1b"
import script from "./HistoryBidComponent.vue?vue&type=script&lang=js"
export * from "./HistoryBidComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoryBidComponent.vue?vue&type=style&index=0&id=480b2a1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports